import { Box, Button, Card, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ConnectToDoctorPopUp = ({
  setConnectToDoctorPopUp,
  childId,
  parentId,
  dob,
}) => {
  const [isDocIdFilled, setIsDocIdFilled] = useState(false);
  const [doctorId, setDoctorId] = useState("");
  const navigate = useNavigate();

  function haandleNavigate() {
    const url = `/doctor-add-child/${childId}/${parentId}`;
    navigate(url, {
      state: {
        doctorId: doctorId,
        dob: dob,
      },
    });
  }
  return (
    <div>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 100,
        }}
      ></Box>
      <div
        style={{
          position: "fixed",
          top: "40%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1000,
          width: "350px",
          height: "150px",
          backgroundColor: "#fff",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
          padding: "10px",
        }}
      >
        <Button
          variant="contained"
          color="error"
          sx={{
            position: "absolute",
            top: -10,
            right: -10,
            minWidth: "30px",
            padding: 0,
            width: "32px",
            height: "32px",
            zIndex: 1000,
          }}
          type="button"
          onClick={() => setConnectToDoctorPopUp(false)}
        >
          X
        </Button>

        <Card
          variant="outlined"
          style={{
            padding: "20px",
            backgroundColor: "#f0f0f0",
            borderRadius: "10px",
            width: "100%",
            height: "100%",
          }}
        >
          {isDocIdFilled ? (
            <Typography>Please confirm Doctor Id: {doctorId}</Typography>
          ) : (
            <TextField
              variant="outlined"
              type="number"
              label="Enter Doctor Id"
              color="primary"
              size="small"
              fullWidth
              sx={{
                mb: 1,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "blue",
                    borderWidth: "2px",
                  },
                  "&:hover fieldset": {
                    borderColor: "blue",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "blue",
                  },
                },
              }}
              onChange={(e) => {
                const value = e.target.value;
                setDoctorId(value.trim());
              }}
            />
          )}

          {isDocIdFilled ? (
            <Button
              variant="contained"
              color="secondary"
              sx={{
                paddingInline: 3,
                textAlign: "center",
                margin: "auto",
                display: "block",
                marginTop: "10px",
              }}
              type="button"
              onClick={haandleNavigate}
            >
              Yes
            </Button>
          ) : (
            <Button
              variant="contained"
              color="secondary"
              sx={{
                paddingInline: 3,
                textAlign: "center",
                margin: "auto",
                display: "block",
                marginTop: "10px",
              }}
              type="button"
              onClick={() => {
                if (doctorId.trim() === "") {
                  toast.warn("Please enter a valid Doctor Id");
                  return;
                };
                setIsDocIdFilled(true);
              }}
            >
              OK
            </Button>
          )}
        </Card>
      </div>
    </div>
  );
};
export default ConnectToDoctorPopUp;
